import { Injectable } from "@angular/core";
import { AuthserviceService } from "./authservice.service";
import { MainService } from "./mainservice";

@Injectable({
  providedIn: "root",
})
export class SubserviceService {
  constructor(
    private mainService: MainService,
    private authService: AuthserviceService
  ) { }

  login(login) {
    const URL = "/user/login";
    return this.mainService.post(URL, login);
  }

  mslogin(email) {
    const URL = "/user/mslogin?emailParam=" + email;
    return this.mainService.get(URL);
  }
  saveCustomer(customer) {
    const URL = "/user/save";
    return this.mainService.postModal(URL, customer);
  }
  getUser() {
    const URL = "/user/listcustomers";
    return this.mainService.get(URL);
  }
  updateCustomer(customer) {
    const URL = "/user/update";
    return this.mainService.updateModal(URL, customer);
  }
  findCustomerUser(id) {
    const URL = "/user/find?id=" + id;
    return this.mainService.findModal(URL);
  }
  getLocations() {
    const URL = "/location/list";
    return this.mainService.get(URL);
  }
  getCountryLocations(id) {
    const URL = "/location/findLocation/Country?id=" + id;
    return this.mainService.get(URL);
  }
  getCountryCustomerLocations(id) {
    const URL = "/customerlocation/listactive/bycountry?id=" + id;
    return this.mainService.get(URL);
  }

// new Added country and role based location get  April 04/2024

getCountryAndRoleBasedgetCustomerLocation(countryId,roleId) {
  const URL = "/customerlocation/listactive/bycountry/enduserRole?id=" + countryId +"&enduserRoleId="+roleId;
  return this.mainService.get(URL);
}

  findCustomerLocation(id) {
    const URL = "/customerlocation/find?id=" + id;
    return this.mainService.get(URL);
  }
  getAccount() {
    const URL = "/accountType/list";
    return this.mainService.get(URL);
  }
  deleteCustomer(id) {
    const URL = "/user/delete?id=" + id;
    return this.mainService.deleteModel(URL);
  }
  // customerDeleteStatusChange(id) {
  //   const URL = "/user/changedeletestatus?id=" + id;
  //   return this.mainService.get(URL);
  // }
  getActiveLocation(id) {
    const URL = "/location/findLocation/Country?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveCountry() {
    const URL = "/country/listactivecountries";
    return this.mainService.get(URL);
  }
  getAccessRightsList() {
    const URL = "/accessRight/list";
    return this.mainService.get(URL);
  }
  getActiveAccessRights() {
    const URL = "/accessRight/listactiverights";
    return this.mainService.get(URL);
  }
  createEndUserRole(data) {
    const URL = "/enduserrole/create";
    return this.mainService.postModal(URL, data);
  }
  deleteEndUserRole(id) {
    const URL = "/enduserrole/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  createUser(data) {
    const URL = "/user/save";
    return this.mainService.postModal(URL, data);
  }
  deleteEndUser(id) {
    const URL = "/user/delete?id=" + id;
    return this.mainService.get(URL);
  }
  createLocation(data) {
    const URL = "/customerlocation/create";
    return this.mainService.postModal(URL, data);
  }
  updateLocation(data) {
    const URL = "/customerlocation/update";
    return this.mainService.putModal(URL, data);
  }
  updateUser(data) {
    const URL = "/user/update";
    return this.mainService.putModal(URL, data);
  }
  editEndUserRole(data) {
    const URL = "/enduserrole/update";
    return this.mainService.postModal(URL, data);
  }
  getEndUserRoles() {
    const URL = "/enduserrole/list";
    return this.mainService.get(URL);
  }
  getActiveEndUserRolesList() {
    const URL = "/enduserrole/listactiveenduserroles";
    return this.mainService.get(URL);
  }
  changeStatus(id) {
    const URL = "/enduserrole/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  changeUserStatus(id) {
    const URL = "/user/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  getEndUsers() {
    const URL = "/user/listEndUsers";
    return this.mainService.get(URL);
  }
  getActiveCountries() {
    const URL = "/country/listactivecountries";
    return this.mainService.get(URL);
  }
  getActiveTimezones() {
    const URL = "/timeZone/listactivetimezones";
    return this.mainService.get(URL);
  }
  getActiveCustomerLocations() {
    const URL = "/customerlocation/listactive";
    return this.mainService.get(URL);
  }
  getActiveCustomerEquipments() {
    const URL = "/customerequipment/listactivecustomerequipments";
    return this.mainService.get(URL);
  }
  getActiveEndUsers() {
    const URL = "/user/listactiveendusers";
    return this.mainService.get(URL);
  }
  getActiveEndUsersForBooking() {
    const URL = "/user/listactiveendusersforbooking";
    return this.mainService.get(URL);
  }
  getActiveCustomerCatering(customerLocationId) {
    const URL =
      "/customercatering/listactive/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  getCustomerLocationCleaning(customerLocationId) {
    const URL =
      "/customercleaning/find/bycustomerlocation?id=" + customerLocationId;
    return this.mainService.get(URL);
  }
  getActiveCustomerMobileEquipment(customerLocationId) {
    const URL =
      "/customermobileequipment/listactive/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  getActiveCustomerITSupport(customerLocationId) {
    const URL =
      "/customeritsupport/listactive/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  getActiveSpecialService(customerLocationId) {
    const URL =
      "/customerspecialservice/listactive/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  getAvailableMeetingRooms(
    customerLocationId,
    customerEquipmentIds,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/meetingRoom/listmeetingrooms/bylocationandequipmentandtime?customerLocationId=" +
      customerLocationId +
      "&customerEquipmentIds=" +
      customerEquipmentIds +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }
  getAvailableMeetingRooms2(
    customerLocationId,
    customerEquipmentIds,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId,
    buildingId,
    floorId
  ) {
    const URL =
      "/meetingRoom/listmeetingrooms/bylocationandequipmentandtime?customerLocationId=" +
      customerLocationId +
      "&customerEquipmentIds=" +
      customerEquipmentIds +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "");
    floorId;
    return this.mainService.get(URL);
  }

  getAvailableMeetingRooms1(
    customerLocationId,
    customerEquipmentIds,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId,
    capacityNumber
  ) {
    const URL =
      "/meetingRoom/listmeetingrooms/bylocationandequipmentandtime?customerLocationId=" +
      customerLocationId +
      "&customerEquipmentIds=" +
      customerEquipmentIds +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId +
      "&capacityNumber=" +
      capacityNumber;
    return this.mainService.get(URL);
  }
  getAvailableDesks(
    customerLocationId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/desk/listdesks/bylocationandtime?customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }
  getAvailableDesks2(
    customerLocationId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId,
    buildingId,
    floorId
  ) {
    const URL =
      "/desk/listdesks/bylocationandtime?customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "");
    return this.mainService.get(URL);
  }
  getAvailableParkingSeats(
    customerLocationId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/parkingSeat/listparkingseats/bycustomerlocationandtime?customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }
  getAvailableParkingSeats2(
    customerLocationId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId,
    buildingId,
    floorId
  ) {
    const URL =
      "/parkingSeat/listparkingseats/bycustomerlocationandtime?customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "");
    return this.mainService.get(URL);
  }
  saveBooking(booking) {
    const URL = "/booking/create";
    return this.mainService.postModal(URL, booking);
  }
  saveImageLogo(logo) {
    const URL = "/logo/create";
    return this.mainService.postModal(URL, logo);
  }
  getFindLogo(nullValue) {
    const URL = "/logo/find?id=0";
    return this.mainService.get(URL);
  }
  saveEmail(modal) {
    const URL = "/email/save";
    return this.mainService.postModal(URL, modal);
  }
  checkEmail(modal) {
    const URL = "/email/checkEmail";
    return this.mainService.postModal(URL, modal);
  }
  getEmailConfig(useId) {
    const URL = "/email/find?id=" + useId;
    return this.mainService.get(URL);
  }
  updateEmail(modal) {
    const URL = "/email/update";
    return this.mainService.putModal(URL, modal);
  }

  getAllLanguagesByLocationId(id) {
    const URL = "/customerlanguage/list?customerLocationId=" + id;
    return this.mainService.get(URL);
  }
  getAllActiveLanguage() {
    const URL = "/language/listactivelanguages";
    return this.mainService.get(URL);
  }

  getAllLanguagesInformation() {
    const URL = "/language/listlanguagekeyinformation";
    return this.mainService.get(URL);
  }
  createNewLanguage(data) {
    const URL = "/customerlanguage/create";
    return this.mainService.postModal(URL, data);
  }
  languageStatusChange(id) {
    const URL = "/customerlanguage/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  saveParkingSeats(data) {
    const URL = "/customerparkingseatsetting/createorupdate";
    return this.mainService.postModal(URL, data);
  }

  saveCars(data) {
    const URL = "/customercarsetting/createorupdate";
    return this.mainService.postModal(URL, data);
  }
  saveMeetingRoomSet(modal) {
    const URL = "/customermeetingroomsetting/createorupdate";
    return this.mainService.postModal(URL, modal);
  }
  getMeetingRoom(locationId) {
    const URL =
      "/customermeetingroomsetting/find/bycustomerlocation?id=" + locationId;
    return this.mainService.get(URL);
  }
  getDeskSetting(locationId) {
    const URL = "/deskSettings/find/bycustomerlocation?id=" + locationId;
    return this.mainService.get(URL);
  }
  createDeskSettings(modal) {
    const URL = "/deskSettings/save";
    return this.mainService.postModal(URL, modal);
  }
  updateDeskSettings(modal) {
    const URL = "/deskSettings/update";
    return this.mainService.putModal(URL, modal);
  }

  listAllParkingSeats() {
    const URL = "/customerparkingseatsetting/list";
    return this.mainService.get(URL);
  }
  listAllCars() {
    const URL = "/customercarsetting/list";
    return this.mainService.get(URL);
  }
  saveCleaning(modal) {
    const URL = "/customercleaning/createorupdate";
    return this.mainService.postModal(URL, modal);
  }
  findCleaning(locationId) {
    const URL = "/customercleaning/find/bycustomerlocation?id=" + locationId;
    return this.mainService.get(URL);
  }
  saveMobileEquipment(modal) {
    const URL = "/customermobileequipment/create";
    return this.mainService.postModal(URL, modal);
  }
  getMobileEquipment(customerLocationId) {
    const URL =
      "/customermobileequipment/list/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  findMobileEquipment(id) {
    const URL = "/customermobileequipment/find?id=" + id;
    return this.mainService.get(URL);
  }
  updateMobileEquipment(modal) {
    const URL = "/customermobileequipment/update";
    return this.mainService.putModal(URL, modal);
  }
  mobileEquipmentStatusChange(id) {
    const URL = "/customermobileequipment/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  saveCatering(modal) {
    const URL = "/customercatering/create";
    return this.mainService.postModal(URL, modal);
  }
  getCatering(customerLocationId) {
    const URL =
      "/customercatering/list/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  findCatering(id) {
    const URL = "/customercatering/find?id=" + id;
    return this.mainService.get(URL);
  }
  updateCatering(modal) {
    const URL = "/customercatering/update";
    return this.mainService.putModal(URL, modal);
  }
  getCateringStatus(id) {
    const URL = "/customercatering/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  listMeetingRooms() {
    const URL = "/meetingRoom/listmeetingroomsbycustomer";
    return this.mainService.get(URL);
  }

  listMeetingRoomsbyLocation(id) {
    const URL =
      "/meetingRoom/listmeetingroomsbylocation?customerLocationId=" + id;
    return this.mainService.get(URL);
  }

  listMeetingRoomsbyLocationBuildingFloor(locationId, buildingId, floorId) {
    const URL =
      "/meetingRoom/listmeetingroomsbylocation?customerLocationId=" +
      locationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "");
    return this.mainService.get(URL);
  }

  getActiveCustomerWeekdays() {
    const URL = "/weekDay/listweekdays";
    return this.mainService.get(URL);
  }

  getActiveCustomerEquipment() {
    const URL = "/customerequipment/listactivecustomerequipments";
    return this.mainService.get(URL);
  }

  getActiveCustomerEquipmentid(customerLocationId) {
    const URL =
      "/customerequipment/listactivecustomerequipmentsid?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }

  getActiveCustomerEquipmentsListBuildingId(customerLocationId, buildingId) {
    const URL =
      "/customerequipment/listactivecustomerequipmentsid?customerLocationId=" +
      customerLocationId +
      "&buildingId=" +
      buildingId;
    return this.mainService.get(URL);
  }

  changeMeetingRoomStatus(id) {
    const URL = "/meetingRoom/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  createItServices(modal) {
    const URL = "/customeritsupport/create";
    return this.mainService.postModal(URL, modal);
  }
  getAllITService(id) {
    const URL =
      "/customeritsupport/list/bycustomerlocation?customerLocationId=" + id;
    return this.mainService.get(URL);
  }
  findItServicesById(id) {
    const URL = "/customeritsupport/find?id=" + id;
    return this.mainService.get(URL);
  }
  updateITServicesDetails(data) {
    const URL = "/customeritsupport/update";
    return this.mainService.putModal(URL, data);
  }
  itServiceStatusChange(id) {
    const URL = "/customeritsupport/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  createSpecialService(data) {
    const URL = "/customerspecialservice/create";
    return this.mainService.postModal(URL, data);
  }
  getAllSpecialService(id) {
    const URL =
      "/customerspecialservice/list/bycustomerlocation?customerLocationId=" +
      id;
    return this.mainService.get(URL);
  }
  findSpecialServiceByID(id) {
    const URL = "/customerspecialservice/find?id=" + id;
    return this.mainService.get(URL);
  }
  updateSpecialServiceDetails(data) {
    const URL = "/customerspecialservice/update";
    return this.mainService.putModal(URL, data);
  }
  specialServiceStatusChange(id) {
    const URL = "/customerspecialservice/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  saveLabourHourse(modal) {
    const URL = "/customerlabourhour/createorupdate";
    return this.mainService.postModal(URL, modal);
  }
  findLabourHours(id) {
    const URL = "/customerlabourhour/find/bycustomerlocation?id=" + id;
    return this.mainService.get(URL);
  }
  saveLogo(file, imageUrl) {
    const URL = "/logo/create";
    return this.mainService.saveLogo(URL, file, imageUrl);
  }

  findMeetingRooms(id) {
    const URL = "/meetingRoom/find?id=" + id;
    return this.mainService.findModal(URL);
  }

  updateMeetingRooms(updateRoom, fileData) {
    const URL = "/meetingRoom/update";
    return this.mainService.updateWithFormData(URL, fileData, updateRoom);
  }

  listDesksUnassignedOpenSpaces() {
    const URL = "/desk/listDesksUnassignedOpenSpaces";
    return this.mainService.get(URL);
  }
  listDesksbyLocation(id) {
    const URL = "/desk/listdesksbylocation?customerLocationId=" + id;
    return this.mainService.get(URL);
  }

  listDesksbyLocationBuildingFloor(locationId, buildingId, floorId) {
    const URL =
      "/desk/listdesksbylocation?customerLocationId=" +
      locationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "");
    return this.mainService.get(URL);
  }

  listRoomService() {
    const URL = "/roomService/listroomservices";
    return this.mainService.get(URL);
  }

  listDesksAssignedOpenSpaces(id) {
    const URL = "/desk/listdesksbyopenspace?openSpaceId=" + id;
    return this.mainService.get(URL);
  }

  deleteOpenSpace(id) {
    const URL = "/openSpace/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  deleteDisplay(id) {
    const URL = "/display/delete?id=" + id;
    return this.mainService.get(URL);
  }

  changeDesksStatus(id) {
    const URL = "/desk/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  saveReporting(modal) {
    const URL = "/report/save";
    return this.mainService.postModal(URL, modal);
  }
  findReport(id) {
    const URL = "/report/listbycustomerlocation?customerLocationId=" + id;
    return this.mainService.get(URL);
  }
  updateReporting(modal) {
    const URL = "/report/update";
    return this.mainService.putModal(URL, modal);
  }
  getCustomerLocation() {
    const URL = "/customerlocation/listactive";
    return this.mainService.get(URL);
  }
  getMeetingRooms() {
    const URL = "/meetingRoom/listmeetingroomsbycustomer";
    return this.mainService.get(URL);
  }
  getDesks() {
    const URL = "/desk/listdesksbycustomer";
    return this.mainService.get(URL);
  }
  createDisplays(modal) {
    const URL = "/display/create";
    return this.mainService.postModal(URL, modal);
  }
  updateDisplay(modal, file) {
    const URL = "/display/update";
    return this.mainService.displayUpdateWithFormData(URL, file, modal);
  }
  getDisplay() {
    const URL = "/display/listdisplays";
    return this.mainService.get(URL);
  }
  findDisplay(id) {
    const URL = "/display/find?id=" + id;
    return this.mainService.get(URL);
  }
  changeDisplayStatus(id) {
    const URL = "/display/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  createMeetingRoomQRCode(id) {
    const URL = "/meetingRoom/createQRCode?id=" + id;
    return this.mainService.findModal(URL);
  }
  createDeskQRCode(id) {
    const URL = "/desk/createQRCode?id=" + id;
    return this.mainService.findModal(URL);
  }

  createOpenSpace(data) {
    const URL = "/openSpace/save";
    return this.mainService.postModal(URL, data);
  }
  getOpenSpace() {
    let userId = this.authService.getUserId();
    // const URL = "/openSpace/listopenspacesbyuser?userId=" + userId;
    const URL = "/openSpace/listopenspacesbyuser";
    return this.mainService.getOpenSpace(URL);
  }

  updateOpenSpace(openSpace) {
    const URL = "/openSpace/update";
    return this.mainService.updateOpenSpaceModal(URL, openSpace);
  }

  //@Thomas Start//
  //parking seats
  parkingSeatsList() {
    const URL = "/parkingSeat/listparkingseats";
    return this.mainService.get(URL);
  }
  parkingSeatsListByLocation(customerLocationId) {
    const URL =
      "/parkingSeat/listparkingseats/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }

  parkingSeatsListByLocationBuildingFloor(locationId, buildingId, floorId) {
    const URL =
      "/parkingSeat/listparkingseats/bycustomerlocation?customerLocationId=" +
      locationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "");
    return this.mainService.get(URL);
  }

  parkingSeatsStatus(id) {
    const URL = "/parkingSeat/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  parkingSeatsFind(id) {
    const URL = "/parkingSeat/find?id=" + id;
    return this.mainService.get(URL);
  }

  UpdateParkingSeatsService(data) {
    const URL = "/parkingSeat/update";
    return this.mainService.postModal(URL, data);
  }

  //kiosks
  kiosksList() {
    const URL = "/kiosk/listkiosks";
    return this.mainService.get(URL);
  }

  kiosksStatus(id) {
    const URL = "/kiosk/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  kiosksDataFind(id) {
    const URL = "/kiosk/find?id=" + id;
    return this.mainService.get(URL);
  }

  kioksUpdateService(data, file) {
    const URL = "/kiosk/update";
    return this.mainService.postKiosk(URL, data, file);
  }

  kiosksQRcode(id) {
    const URL = "/kiosk/createQRCode?id=" + id;
    return this.mainService.get(URL);
  }

  //View point

  viewPointList() {
    const URL = "/viewPoint/listviewpointsbycustomer";
    return this.mainService.get(URL);
  }

  viewPointStatus(id) {
    const URL = "/viewPoint/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  viewPointFind(id) {
    const URL = "/viewPoint/find?id=" + id;
    return this.mainService.get(URL);
  }

  viewPointUpdateService(data, file) {
    const URL = "/viewPoint/update";
    return this.mainService.postViewPoint(URL, data, file);
  }

  //Calendar

  getAvailableEventByLocation(customerLocationId) {
    const URL =
      "/booking/listbyfilters?customerLocationId=" + customerLocationId;
    return this.mainService.get(URL);
  }
  getAvailableEventByBookingType(bookingType, customerLocationId) {
    const URL =
      "/booking/listbyfilters?bookingType=" +
      bookingType +
      "&customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  getAvailableEventByDates(
    bookingType,
    customerLocationId,
    startDate,
    endDate
  ) {
    const URL =
      "/booking/listbyfilters?bookingType=" +
      bookingType +
      "&customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&endDate=" +
      endDate;
    return this.mainService.get(URL);
  }

  getAvailableEventByDates1(
    bookingType,
    customerLocationId,
    startDate,
    endDate,
    buildingList,
    floorList
  ) {
    const URL =
      "/booking/listbyfilters?bookingType=" +
      bookingType +
      "&customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&buildingList=" +
      buildingList +
      "&floorList=" +
      floorList;
    return this.mainService.get(URL);
  }

  getParkingSeatsByLocation(parkingSeats) {
    const URL = "/booking/listbyfilters?customerLocationId=" + parkingSeats;
    return this.mainService.get(URL);
  }

  deleteBooking(id) {
    const URL = "/booking/delete?id=" + id;
    return this.mainService.deleteModel(URL);
  }

  //@Thomas End//

  updateDesk(updateDesk, fileData) {
    const URL = "/desk/update";
    return this.mainService.deskUpdateWithFormData(URL, updateDesk, fileData);
  }

  findDesk(id) {
    const URL = "/desk/find?id=" + id;
    return this.mainService.findModal(URL);
  }

  findOpenSpace(id) {
    const URL = "/openSpace/find?id=" + id;
    return this.mainService.get(URL);
  }
  getMobileEquipmentIcon() {
    const URL = "/equipmentIcon/listactiveequipmenticons";
    return this.mainService.get(URL);
  }
  saveEquipments(modal) {
    const URL = "/customerequipment/save";
    return this.mainService.postModal(URL, modal);
  }
  getEquipments() {
    const URL = "/customerequipment/listcustomerequipments";
    return this.mainService.get(URL);
  }

  getEquipmentsid(customerLocationId) {
    const URL =
      "/customerequipment/listcustomerequipmentsid?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  findEquipment(id) {
    const URL = "/customerequipment/find?id=" + id;
    return this.mainService.get(URL);
  }
  updateEquipment(modal) {
    const URL = "/customerequipment/update";
    return this.mainService.putModal(URL, modal);
  }
  equipmentStatusChange(id) {
    const URL = "/customerequipment/activateordeactivate?id=" + id;
    return this.mainService.get(URL);
  }
  saveAlignment(value) {
    const URL = "/customerequipment/savealignment?alignment=" + value;
    return this.mainService.get(URL);
  }
  getAlignment() {
    const URL = "/customerequipment/getalignment";
    return this.mainService.get(URL);
  }
  findParkingSeats(id) {
    const URL = "/customerparkingseatsetting/find/bycustomerlocation?id=" + id;
    return this.mainService.get(URL);
  }
  findCars(id) {
    const URL = "/customercarsetting/find/bycustomerlocation?id=" + id;
    return this.mainService.get(URL);
  }

  findStyleSetting() {
    const URL = "/styleSetting/find";
    return this.mainService.get(URL);
  }
  saveStyleSettings(
    styleSettingsData,
    kioskCheckinFile,
    kioskCheckInformation,
    serviceViewPont
  ) {
    const URL = "/styleSetting/update";
    return this.mainService.putStykeSettingsFile(
      URL,
      styleSettingsData,
      kioskCheckinFile,
      kioskCheckInformation,
      serviceViewPont
    );
  }
  getEquipmentAlignment() {
    const URL = "/customerequipment/getalignment";
    return this.mainService.get(URL);
  }
  saveDemoAccount(data) {
    const URL = "/user/savedemocustomer";
    return this.mainService.post(URL, data);
  }
  getCountryList() {
    const URL = "/country/listcountrieswithouttoken";
    return this.mainService.getcountry(URL);
  }

  changeOpenSpaceStatus(id) {
    const URL = "/openSpace/activateordeactivate?id=" + id;
    return this.mainService.get(URL);
  }
  uploadCsvDocument(data) {
    const URL = "/upload/uploadUserData";
    return this.mainService.postCsv(URL, data);
  }
  findBooking(id) {
    const URL = "/booking/find?id=" + id;
    return this.mainService.findModal(URL);
  }

  // Francis
  extendDuration(data) {
    const URL = "/booking/extend";
    return this.mainService.postExtendTimeDur(URL, data);
  }

  endMeeting(id) {
    const URL = "/booking/end?id=" + id;
    return this.mainService.get(URL);
  }

  getMeetingRoomBookingByLocation(id) {
    const URL =
      "/meetingRoom/listmeetingroomsbylocation?customerLocationId=" + id;
    return this.mainService.findModal(URL);
  }
  getDeskBookingByLocation(id) {
    const URL = "/desk/listdesksbylocation?customerLocationId=" + id;
    return this.mainService.findModal(URL);
  }
  getEquipmentByLocation(id) {
    const URL =
      "/meetingRoom/listmeetingrooms/bylocationandequipment?locationId=" + id;
    return this.mainService.findModal(URL);
  }

  //
  getEquipmentIdsWithLocationId(data) {
    const URL = "/meetingRoom/listmeetingrooms/bylocationandequipment";
    return this.mainService.postEquipAndLocationIds(URL, data);
  }
  // end

  getEndUserBooking() {
    const URL = "/dashboardEndUser/dashboardenduserservice";
    return this.mainService.get(URL);
  }
  allowBooking(allowValue, id) {
    const URL = "/booking/allowbookingbyenduser";
    return this.mainService.allowEndUser(URL, allowValue, id);
  }
  changeEmailConfigurationStatus(status, id) {
    const URL = "/email/changeStatus?id=" + id + "&status=" + status;
    return this.mainService.get(URL);
  }
  changeLogoConfigurationStatus(status, id) {
    const URL = "/logo/changeStatus?id=" + id + "&status=" + status;
    return this.mainService.get(URL);
  }
  getLogoByUser() {
    const URL = "/logo/findbyloggedinuser";
    return this.mainService.get(URL);
  }
  findCustomerReport(id) {
    const URL = "/report/listbycustomeradmin";
    return this.mainService.get(URL);
  }
  deleteSpecialService(id) {
    const URL = "/customerspecialservice/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  deleteITsupportService(id) {
    const URL = "/customeritsupport/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  deleteCatering(id) {
    const URL = "/customercatering/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  deleteMobileEquipment(id) {
    const URL = "/customermobileequipment/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  deleteEquipment(id) {
    const URL = "/customerequipment/delete?id=" + id;
    return this.mainService.delete(URL);
  }

  getCustomerLocationByMeetingRoom(id) {
    const URL =
      "/meetingRoom/listmeetingroomsbylocation?customerLocationId=" + id;
    return this.mainService.get(URL);
  }
  getMeetingRoomByEquipment(meetingRoomId) {
    const URL =
      "/meetingRoomEquipment/listmeetingroomequipmentsbymeetingroom?meetingRoomId=" +
      meetingRoomId;
    return this.mainService.get(URL);
  }
  saveReportEquipment(reportEquipmentModal) {
    const URL = "/reportEquipment/reportbyenduser";
    return this.mainService.postModal(URL, reportEquipmentModal);
  }
  saveReportEquipmentByCustomeradmin(reportEquipmentModal) {
    const URL = "/reportEquipment/fixbycustomeradmin";
    return this.mainService.postModal(URL, reportEquipmentModal);
  }
  changePassword(modal) {
    const URL = "/user/changepassword";
    return this.mainService.postModal(URL, modal);
  }
  findUser(id) {
    const URL = "/user/find?id=" + id;
    return this.mainService.get(URL);
  }
  getDashboardEndUser() {
    const URL = "/dashboardEndUser/dashboardenduser";
    return this.mainService.get(URL);
  }
  getDashboardEndUserService() {
    const URL = "/dashboardEndUser/dashboardenduserservice";
    return this.mainService.get(URL);
  }

  getDashboardCustomerAdminService(
    customerLocationId,
    resourceType,
    startDate,
    endDate,
    csvReport
  ) {
    const URL =
      "/dashboardCustomerAdmin/dashboardcustomeradminservice?customerLocationId=" +
      customerLocationId +
      "&resourceType=" +
      resourceType +
      "&startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&csvReport=" +
      csvReport;
    return this.mainService.get(URL);
  }
  getDashboardCustomerAdmin() {
    const URL = "/dashboardCustomerAdmin/dashboardcustomeradmin";
    return this.mainService.get(URL);
  }
  getDashboardBackOfficeAdmin() {
    const URL = "/dashboardBackOfficeAdmin/dashboardbackofficeadmin";
    return this.mainService.get(URL);
  }
  dashboardBackOfficeAdminBetweenDates(startDate, endDate) {
    const URL =
      "/dashboardBackOfficeAdmin/dashboardbackofficeadminbetweendates?startDateParam=" +
      startDate +
      "&endDateParam=" +
      endDate;
    return this.mainService.get(URL);
  }
  downloadCSV(startDate, endDate) {
    const URL =
      "/dashboardBackOfficeAdmin/createcsvbetweendates?startDateParam=" +
      startDate +
      "&endDateParam=" +
      endDate;
    return this.mainService.get(URL);
  }
  dashboardCustomerAdminBetweenDates(startDate, endDate) {
    const URL =
      "/dashboardCustomerAdmin/dashboardcustomeradminbetweendates?startDateParam=" +
      startDate +
      "&endDateParam=" +
      endDate;
    return this.mainService.get(URL);
  }
  downloadCustomerCSV(startDate, endDate) {
    const URL =
      "/dashboardCustomerAdmin/createcsvbetweendates?startDateParam=" +
      startDate +
      "&endDateParam=" +
      endDate;
    return this.mainService.get(URL);
  }
  serviceViewPointFind(id) {
    const URL = "/serviceViewPoint/find?id=" + id;
    return this.mainService.getWithoutToken(URL);
  }
  getForgotPassword(modal) {
    const URL = "/user/forgotpasswordmail";
    return this.mainService.post(URL, modal);
  }
  viewPointListByLocation() {
    const URL = "/serviceViewPoint/listviewpointsbycustomer";
    return this.mainService.get(URL);
  }
  getLocationStatusChange(id) {
    const URL = "/customerlocation/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  getCustomerLocations() {
    const URL = "/customerlocation/list";
    return this.mainService.get(URL);
  }

  changeCleaningtatus(status, id) {
    const URL = "/customercleaning/changeStatus?id=" + id + "&status=" + status;
    return this.mainService.get(URL);
  }
  logoDelete(id) {
    const URL = "/logo/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  changeResetPassword(data) {
    const URL = "/user/forgotpassword";
    return this.mainService.postModal(URL, data);
  }

  uploadAzureUsersOffice365(microsoftToken) {
    const URL =
      "/office365User/importazureusers?microsoftToken=" + microsoftToken;
    return this.mainService.get(URL);
  }

  getAvailableCars(
    customerLocationId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/car/list/bylocationandtime?customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }

  getAvailableCars1(
    customerLocationId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId,
    buildingId,
    floorId
  ) {
    const URL =
      "/car/list/bylocationandtime?customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId +
      "&buildingId=" +
      buildingId +
      "&floorId=" +
      floorId;
    return this.mainService.get(URL);
  }

  listCars() {
    const URL = "/car/list/byloggedinuser";
    return this.mainService.get(URL);
  }

  changeCarStatus(id) {
    const URL = "/car/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  findCar(id) {
    const URL = "/car/find?id=" + id;
    return this.mainService.findModal(URL);
  }

  updateCar(updateCar, fileData) {
    const URL = "/car/update";
    return this.mainService.carUpdateWithFormData(URL, fileData, updateCar);
  }

  saveAutoRepairShop(data) {
    const URL = "/car/saveAutoRepairShop";
    return this.mainService.postModal(URL, data);
  }
  listAutoRepairShop(id) {
    const URL = "/car/listbycarid?id= " + id;
    return this.mainService.get(URL);
  }

  checkoutCarBooking(checkoutData, fileData) {
    const URL = "/booking/checkout";
    return this.mainService.carCheckoutWithFormData(
      URL,
      fileData,
      checkoutData
    );
  }

  getNewsLetterSubscription() {
    const URL = "/website/newslettersubscription/list";
    return this.mainService.get(URL);
  }

  // SPACE
  getSpaceList() {
    const URL = "/space/list";
    return this.mainService.get(URL);
  }
  createSpaces(data) {
    const URL = "/space/saveSpace";
    return this.mainService.postModal(URL, data);
  }

  spaceDelete(id) {
    const URL = "/space/delete?id=" + id;
    return this.mainService.delete(URL);
  }

  // deleteSpaces(data) {
  //     const URL = "/space/delete"
  //     return this.mainService.postModal(URL, data)
  //   }

  updateSpaces(data) {
    const URL = "/space/update";
    return this.mainService.postModal(URL, data);
  }

  cropSave(data) {
    const URL = "/space/addSpaceCrop";
    return this.mainService.postModal(URL, data);
  }
  findSpace(id) {
    const URL = "/space/find?id=" + id;
    return this.mainService.findModal(URL);
  }

  findCapacity(id) {
    const URL = "/booking/findcapacity?id=" + id;
    return this.mainService.findModal(URL);
  }

  cropDelete(data) {
    const URL = "/space/removeSpaceCrop";
    return this.mainService.putModal(URL, data);
  }
  checkBooking(data) {
    const URL = "/booking/bookingStatus";
    return this.mainService.postModal(URL, data);
  }

  changeSpaceStatus(id) {
    const URL = "/space/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  //laia
  getLaiacustomers() {
    const URL = "/user/customerAdminList ";
    return this.mainService.getLaia(URL);
  }

  getUserById(id: any) {
    const URL = "/user/findUserById?id=" + id;
    return this.mainService.getLaia(URL);
  }

  getActiveLocationLaia(id) {
    const URL = "/location/findLocationByCountry?id=" + id;
    return this.mainService.getLaia(URL);
  }

  getAccountLaia() {
    const URL = "/accountType/accountTypeList";
    return this.mainService.getLaia(URL);
  }

  getActiveCountryLaia() {
    const URL = "/country/activeCountryList";
    return this.mainService.getLaia(URL);
  }

  // Customer Catering Setting
  createCateringSetting(data) {
    const URL = "/customercateringsetting/createorupdate";
    return this.mainService.postModal(URL, data);
  }
  getCateringSetting(locationId) {
    const URL =
      "/customercateringsetting/find/bycustomerlocation?id=" + locationId;
    return this.mainService.get(URL);
  }

  //Customer Special Service
  createSpecialServiceSetting(data) {
    const URL = "/customerspecialservicesetting/createorupdate";
    return this.mainService.postModal(URL, data);
  }
  getSpecialServiceSetting(locationId) {
    const URL =
      "/customerspecialservicesetting/find/bycustomerlocation?id=" + locationId;
    return this.mainService.get(URL);
  }

  //Customer IT Support Setting
  getITSupportSetting(locationId) {
    const URL =
      "/customeritsupportsetting/find/bycustomerlocation?id=" + locationId;
    return this.mainService.get(URL);
  }
  createITSupportSetting(data) {
    const URL = "/customeritsupportsetting/createorupdate";
    return this.mainService.postModal(URL, data);
  }

  //Customer Mobile Equipment Support Setting
  getMobileEquipmentSetting(locationId) {
    const URL =
      "/customermobileequipmentsetting/find/bycustomerlocation?id=" +
      locationId;
    return this.mainService.get(URL);
  }
  createMobileEquipmentSetting(data) {
    const URL = "/customermobileequipmentsetting/createorupdate";
    return this.mainService.postModal(URL, data);
  }
  deleteParkingSeatDetail(id) {
    const URL = "/booking/deleteparkingseatdetail?id=" + id;
    return this.mainService.deleteModel(URL);
  }
  // Charging Car Settings
  saveChargingCarSetting(data) {
    const URL = "/customerchargingcarsetting/createorupdate";
    return this.mainService.postModal(URL, data);
  }
  findChargingCarSetting(id) {
    const URL = "/customerchargingcarsetting/find/bycustomerlocation?id=" + id;
    return this.mainService.get(URL);
  }

  //Customer Charging Car
  loadChargingCar(customerLocationId) {
    const URL =
      "/customerchargingcar/list/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  saveChargingCar(modal) {
    const URL = "/customerchargingcar/create";
    return this.mainService.postModal(URL, modal);
  }
  getChargingCar(customerLocationId) {
    const URL =
      "/customerchargingcar/list/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  updateChargingCar(modal) {
    const URL = "/customerchargingcar/update";
    return this.mainService.putModal(URL, modal);
  }
  deleteChargingCar(id) {
    const URL = "/customerchargingcar/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  chargingCarStatusChange(id) {
    const URL = "/customerchargingcar/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  //Charging Car
  chargingCarList() {
    const URL = "/chargingcar/listchargingcars";
    return this.mainService.get(URL);
  }
  chargingCarFind(id) {
    const URL = "/chargingcar/find?id=" + id;
    return this.mainService.get(URL);
  }
  updateChargingCarService(data) {
    const URL = "/chargingcar/update";
    return this.mainService.postModal(URL, data);
  }
  chargingCarStatus(id) {
    const URL = "/chargingcar/changestatus?id=" + id;
    return this.mainService.get(URL);
  }

  //Charging Car For Booking
  getAvailableChargingCars(
    customerLocationId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/chargingcar/listchargingcars/bycustomerlocationandtime?customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }

  getAvailableChargingCars2(
    customerLocationId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId,
    buildingId,
    floorId
  ) {
    const URL =
      "/chargingcar/listchargingcars/bycustomerlocationandtime?customerLocationId=" +
      customerLocationId +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "");
    return this.mainService.get(URL);
  }
  getActiveChargingCarDuration(customerLocationId) {
    const URL =
      "/customerchargingcar/listactive/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }
  chargingCarsListByLocation(customerLocationId) {
    const URL =
      "/chargingcar/listchargings/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
  }

  chargingCarsListByLocationBuildingFloor(locationId, buildingId, floorId) {
    const URL =
      "/chargingcar/listchargings/bycustomerlocation?customerLocationId=" +
      locationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "");
    return this.mainService.get(URL);
  }

  //get resource booking list
  getSpecificResourceList(data) {
    const URL = "/booking/listbyfilterswithresource";
    return this.mainService.postModal(URL, data);
  }
  getResourceListByCustomerLocation(id) {
    const URL =
      "/customerlocation/findBuildingresourcebycustomerlocation?id=" + id;
    return this.mainService.get(URL);
  }
  getResourceList(id) {
    const URL = "/customerlocation/findresourcebycustomerlocation?id=" + id;
    return this.mainService.get(URL);
  }
  getResourceRightList() {
    const URL = "/resourceaccessright/list";
    return this.mainService.get(URL);
  }
  createResourceRights(data) {
    const URL = "/resourceaccessright/create";
    return this.mainService.postModal(URL, data);
  }
  getResourceRight(id) {
    const URL = "/resourceaccessright/find?id=" + id;
    return this.mainService.get(URL);
  }
  updateResourceRights(data) {
    const URL = "/resourceaccessright/update";
    return this.mainService.postModal(URL, data);
  }
  deleteResourceRights(id) {
    const URL = "/resourceaccessright/delete?id=" + id;
    return this.mainService.get(URL);
  }
  changeResourceRightsStatus(id) {
    const URL = "/resourceaccessright/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveResourceRightList() {
    const URL = "/resourceaccessright/listbycustomeradmin";
    return this.mainService.get(URL);
  }
  findResourceRightForRole(id) {
    const URL = "/resourceaccessright/find?id=" + id;
    return this.mainService.get(URL);
  }
  getBuildingListByCustomerLocation(id) {
    const URL = "/building/listbycustomerlocation?id=" + id;
    return this.mainService.get(URL);
  }
  createBuilding(data) {
    const URL = "/building/create";
    return this.mainService.postModal(URL, data);
  }
  findBuilding(id) {
    const URL = "/building/find?id=" + id;
    return this.mainService.get(URL);
  }
  updateBuilding(data) {
    const URL = "/building/update";
    return this.mainService.putModal(URL, data);
  }
  deleteBuilding(id) {
    const URL = "/building/delete?id=" + id;
    return this.mainService.deleteModel(URL);
  }
  getFloorListByBuilding(id) {
    const URL = "/floor/listbybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  updateFloor(data) {
    const URL = "/floor/update";
    return this.mainService.putModal(URL, data);
  }
  createFloor(data) {
    const URL = "/floor/create";
    return this.mainService.postModal(URL, data);
  }
  deleteFloor(id) {
    const URL = "/floor/delete?id=" + id;
    return this.mainService.deleteModel(URL);
  }
  findFloor(id) {
    const URL = "/floor/find?id=" + id;
    return this.mainService.get(URL);
  }

  //Building Settings
  findLabourHoursByBuilding(id) {
    const URL = "/customerlabourhour/find/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getMeetingRoomByBuilding(locationId) {
    const URL = "/customermeetingroomsetting/find/bybuilding?id=" + locationId;
    return this.mainService.get(URL);
  }
  getDeskSettingByBuilding(locationId) {
    const URL = "/deskSettings/find/bybuilding?id=" + locationId;
    return this.mainService.get(URL);
  }
  findParkingSeatsByBuilding(id) {
    const URL = "/customerparkingseatsetting/find/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  findChargingCarSettingByBuilding(id) {
    const URL = "/customerchargingcarsetting/find/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getChargingCarByBuilding(customerLocationId) {
    const URL = "/customerchargingcar/list/bybuilding?id=" + customerLocationId;
    return this.mainService.get(URL);
  }
  findCarsByBuilding(id) {
    const URL = "/customercarsetting/find/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  findCleaningByBuilding(locationId) {
    const URL = "/customercleaning/find/bybuilding?id=" + locationId;
    return this.mainService.get(URL);
  }
  getEquipmentsByBuilding(id) {
    const URL = "/customerequipment/listequipmentsbybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getMobileEquipmentSettingByBuilding(locationId) {
    const URL =
      "/customermobileequipmentsetting/find/bybuilding?id=" + locationId;
    return this.mainService.get(URL);
  }
  getMobileEquipmentByBuilding(buildingId) {
    const URL = "/customermobileequipment/list/bybuilding?id=" + buildingId;
    return this.mainService.get(URL);
  }
  getCateringSettingByBuilding(id) {
    const URL = "/customercateringsetting/find/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getCateringByBuilding(id) {
    const URL = "/customercatering/list/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getITSupportSettingByBuilding(id) {
    const URL = "/customeritsupportsetting/find/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getAllITServiceByBuilding(id) {
    const URL = "/customeritsupport/list/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getSpecialServiceSettingByBuilding(id) {
    const URL = "/customerspecialservicesetting/find/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getAllSpecialServiceByBuilding(id) {
    const URL = "/customerspecialservice/list/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveCustomerEquipmentByBuilding(id) {
    const URL =
      "/customerequipment/listactivecustomerequipmentsbybuilding?id=" + id;
    return this.mainService.get(URL);
  }

  getActiveCustomerCateringWithBuilding(customerLocationId, buildingId) {
    if (customerLocationId) {
      const URL =
        "/customercatering/listactive/bycustomerlocation?customerLocationId=" +
        customerLocationId;
      return this.mainService.get(URL);
    } else {
      const URL =
        "/customercatering/listactive/bycustomerlocation?buildingId=" +
        buildingId;
      return this.mainService.get(URL);
    }
  }

  getActiveCustomerMobileEquipmentWithBuilding(customerLocationId, buildingId) {
    if (customerLocationId) {
      const URL =
        "/customermobileequipment/listactive/bycustomerlocation?customerLocationId=" +
        customerLocationId;
      return this.mainService.get(URL);
    } else {
      const URL =
        "/customermobileequipment/listactive/bycustomerlocation?buildingId=" +
        buildingId;
      return this.mainService.get(URL);
    }
  }

  getActiveCustomerITSupportWithBuilding(customerLocationId, buildingId) {
    if (customerLocationId) {
      const URL =
        "/customeritsupport/listactive/bycustomerlocation?customerLocationId=" +
        customerLocationId;
      return this.mainService.get(URL);
    } else {
      const URL =
        "/customeritsupport/listactive/bycustomerlocation?buildingId=" +
        buildingId;
      return this.mainService.get(URL);
    }
  }

  getActiveSpecialServiceWithBuilding(customerLocationId, buildingId) {
    if (customerLocationId) {
      const URL =
        "/customerspecialservice/listactive/bycustomerlocation?customerLocationId=" +
        customerLocationId;
      return this.mainService.get(URL);
    } else {
      const URL =
        "/customerspecialservice/listactive/bycustomerlocation?buildingId=" +
        buildingId;
      return this.mainService.get(URL);
    }
  }

  getAvailableMeetingRoomsWithBuildingAndFloor(
    customerLocationId,
    buildingId,
    floorId,
    customerEquipmentIds,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/meetingRoom/listmeetingrooms/bylocationandequipmentandtime/v1?customerLocationId=" +
      customerLocationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "") +
      (customerEquipmentIds && customerEquipmentIds.length > 0
        ? "&customerEquipmentIds=" + customerEquipmentIds
        : "") +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }

  getAvailableMeetingRooms1WithBuildingAndFloor(
    customerLocationId,
    buildingId,
    floorId,
    customerEquipmentIds,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId,
    capacityNumber
  ) {
    const URL =
      "/meetingRoom/listmeetingrooms/bylocationandequipmentandtime/v1?customerLocationId=" +
      customerLocationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "") +
      (customerEquipmentIds && customerEquipmentIds.length > 0
        ? "&customerEquipmentIds=" + customerEquipmentIds
        : "") +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId +
      (capacityNumber ? "&capacityNumber=" + capacityNumber : "");
    return this.mainService.get(URL);
  }

  getAvailableDesksWithBuildingAndFloor(
    customerLocationId,
    buildingId,
    floorId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/desk/listdesks/bylocationandtime/v1?customerLocationId=" +
      customerLocationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "") +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }

  getAvailableParkingSeatsWithBuildingAndFloor(
    customerLocationId,
    buildingId,
    floorId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/parkingSeat/listparkingseats/bycustomerlocationandtime/v1?customerLocationId=" +
      customerLocationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "") +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }

  getActiveCustomerEquipmentidWithBuilding(customerLocationId, buildingId) {
    if (customerLocationId) {
      const URL =
        "/customerequipment/listactivecustomerequipmentsid?customerLocationId=" +
        customerLocationId;
      return this.mainService.get(URL);
    } else {
      const URL =
        "/customerequipment/listactivecustomerequipmentsid?buildingId=" +
        buildingId;
      return this.mainService.get(URL);
    }
  }

  findCapacityWithBuildingAndFloor(locationId, buildingId, floorId) {
    if (locationId) {
      const URL = "/booking/findcapacity?id=" + locationId;
      return this.mainService.findModal(URL);
    } else if (buildingId) {
      const URL = "/booking/findcapacity?buildingId=" + buildingId;
      return this.mainService.findModal(URL);
    } else if(floorId.length > 0) {
      const URL = "/booking/findcapacity?floorId=" + floorId;
      return this.mainService.findModal(URL);
    }
  }

  getAvailableChargingCarsWithBuildingAndFloor(
    customerLocationId,
    buildingId,
    floorId,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId
  ) {
    const URL =
      "/chargingcar/listchargingcars/bycustomerlocationandtime/v1?customerLocationId=" +
      customerLocationId +
      (buildingId ? "&buildingId=" + buildingId : "") +
      (floorId ? "&floorId=" + floorId : "") +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId;
    return this.mainService.get(URL);
  }

  getActiveChargingCarDurationWithBuilding(customerLocationId, buildingId) {
    if ((buildingId) && (buildingId != '0') && (buildingId != 'null')) {
      const URL =
      "/customerchargingcar/listactive/bycustomerlocation?buildingId=" +
      buildingId;
    return this.mainService.get(URL);
    } else {
      const URL =
      "/customerchargingcar/listactive/bycustomerlocation?customerLocationId=" +
      customerLocationId;
    return this.mainService.get(URL);
    }
  }

  getBuildingListByCustomerLocationAndStatus(id, status) {
    if (status) {
      const URL =
        "/building/listbycustomerlocation?id=" + id + "&status=" + status;
      return this.mainService.get(URL);
    } else {
      const URL = "/building/listbycustomerlocation?id=" + id;
      return this.mainService.get(URL);
    }
  }

  getFloorListByBuildingAndStatus(id, status) {
    if (status) {
      const URL = "/floor/listbybuilding?id=" + id + "&status=" + status;
      return this.mainService.get(URL);
    } else {
      const URL = "/floor/listbybuilding?id=" + id;
      return this.mainService.get(URL);
    }
  }
  getBuildingStatusChange(id) {
    const URL = "/building/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveCustomerCateringByBuilding(id) {
    const URL = "/customercatering/listactive/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveCustomerMobileEquipmentByBuilding(id) {
    const URL = "/customermobileequipment/listactive/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveCustomerITSupportByBuilding(id) {
    const URL = "/customeritsupport/listactive/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveSpecialServiceByBuilding(id) {
    const URL = "/customerspecialservice/listactive/bybuilding?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveBuildingListByCustomerLocation(id) {
    const URL = "/building/listactive?id=" + id;
    return this.mainService.get(URL);
  }
  getAllResourceByBuilding(id) {
    const URL = "/building/filterallresourcebybuilding?id=" + id;
    return this.mainService.get(URL);
  }

  getMeetingRoomByBuildingId(buildingId, floorId) {
    // const URL ="/meetingRoom/listMeetingRoom?buildingId="+buildingId+"floorId"+floorId;
    const URL =
      "/meetingRoom/listMeetingRoom?buildingId=" +
      buildingId +
      "&floorId=" +
      floorId;
    return this.mainService.get(URL);
  }

  getFloorStatusChange(id) {
    const URL = "/floor/changestatus?id=" + id;
    return this.mainService.get(URL);
  }
  getActiveFloorByBuilding(id) {
    const URL = "/floor/listactive?id=" + id;
    return this.mainService.get(URL);
  }

  //new
  findByRoomBasedFilter(
    customerLocationId,
    customerEquipmentIds,
    startDate,
    startTime,
    endDate,
    endTime,
    editBookingId,
    capacityNumber,
    roomId,
    deskId,
    parkingId,
    chargingId
  ) {
    const URL =
      "/meetingRoom/listmeetingrooms/byresourcebasedfind?customerLocationId=" +
      customerLocationId +
      "&customerEquipmentIds=" +
      customerEquipmentIds +
      "&startDate=" +
      startDate +
      "&startTime=" +
      startTime +
      "&endDate=" +
      endDate +
      "&endTime=" +
      endTime +
      "&editBookingId=" +
      editBookingId +
      "&capacityNumber=" +
      capacityNumber +
      "&roomId=" +
      roomId +
      "&deskId=" +
      deskId +
      "&parkingId=" +
      parkingId +
      "&chargingId=" +
      chargingId;
    return this.mainService.get(URL);
  }

  findByFloorBasedFilter(id) {
    const URL = "/floor/floorBasedFilter?id=" + id;
    return this.mainService.get(URL);
  }
  getDeskByBuildingId(buildingId, floorId) {
    const URL =
      "/desk/desklistbyBuildingFloor?buildingId=" +
      buildingId +
      "&floorId=" +
      floorId;
    return this.mainService.get(URL);
  }

  getParkingSeatByBuildingId(buildingId, floorId) {
    const URL =
      "/parkingSeat/parkingSeatbyBuildingFloor?buildingId=" +
      buildingId +
      "&floorId=" +
      floorId;
    return this.mainService.get(URL);
  }

  getChargingCarByBuildingId(buildingId, floorId) {
    const URL =
      "/chargingcar/chargingCarlistbyBuildingFloor?buildingId=" +
      buildingId +
      "&floorId=" +
      floorId;
    return this.mainService.get(URL);
  }

  getFloorResource(id) {
    const URL = "/floor/findresourcebyfloor?id=" + id;
    return this.mainService.get(URL);
  }
  getBuildingResource(id) {
    const URL = "/building/filterallresourcebybuilding?id=" + id;
    return this.mainService.get(URL);
  }

  getCarByBuildingId(buildingId, floorId) {
    const URL =
      "/car/listCarbyBuilding?buildingId=" + buildingId + "&floorId=" + floorId;
    return this.mainService.get(URL);
  }

  findCarByLocation(locationId) {
    const URL =
      "/car/list/bycustomerlocationId?customerLocationId=" + locationId;
    return this.mainService.get(URL);
  }

  getFloorListByBuildingIds(ids) {
    const URL =
      "/floor/listactivebybuildingids?buildingIds=" + ids;
    return this.mainService.get(URL);
  }

  listMeetingRoomsbyLocation1(id, buildingId, floorId) {
    const URL = "/meetingRoom/listmeetingroomsbylocationsandbuilding?customerLocationId=" + id + "&buildingId=" + Number(buildingId) + "&floorId=" + Number(floorId);
    return this.mainService.get(URL);
  }

  listDesksbyLocation1(id, buildingId, floorId) {
    const URL = "/desk/listdesksbylocationandBuilding?customerLocationId=" + id + "&buildingId=" + Number(buildingId) + "&floorId=" + Number(floorId);
    return this.mainService.get(URL);
  }

  chargingCarsListByLocation1(id, buildingId, floorId) {
    const URL = "/chargingcar/listchargings/bycustomerlocationandbuilding?customerLocationId=" + id + "&buildingId=" + Number(buildingId) + "&floorId=" + Number(floorId);
    return this.mainService.get(URL);
  }

  parkingSeatsListByLocation1(id, buildingId, floorId) {
    const URL = "/parkingSeat/listparkingseats/bycustomerlocationandbuilding?customerLocationId=" + id + "&buildingId=" + Number(buildingId) + "&floorId=" + Number(floorId);
    return this.mainService.get(URL);
  }

  carListByLocation(id) {
    const URL = "/car/list/bycustomerlocation?customerLocationId=" + id;
    return this.mainService.get(URL);
  }

  carListByLocation1(id, buildingId, floorId) {
    const URL = "/car/bycustomerlocationandbuilding?customerLocationId=" + id + "&buildingId=" + Number(buildingId) + "&floorId=" + Number(floorId);
    return this.mainService.get(URL);
  }

  getDashboardCustomerAdminService1(customerLocationId, resourceType, resourceName, startDate, endDate, csvReport, buildingId, floorId) {
    const URL = "/dashboardCustomerAdmin/dashboardcustomeradminservice2?customerLocationId=" + customerLocationId + "&resourceType=" + resourceType + "&resourceName=" + resourceName + "&startDate=" + startDate + "&endDate=" + endDate + "&csvReport=" + csvReport + "&buildingId=" + Number(buildingId) + "&floorId=" + Number(floorId);
    return this.mainService.get(URL);
  }
  changeLanguage(data) {
    const URL = "/user/changelanguage?language=" + data;
    return this.mainService.get(URL);
  }


  // Zelo-Vised Based Api 

  getVisitorSettingsValidationFields() {
    const URL = "/visitorfields/find"
    return this.mainService.get(URL);
  }

  updateVisitorValidationFields(data) {
    const URL = "/visitorfields/update"
    return this.mainService.putModal(URL, data);
  }

  getVisitSettingsValidationFields() {
    const URL = "/visitFields/find"
    return this.mainService.get(URL);
  }

  updateVisitValidationFields(data) {
    const URL = "/visitFields/update"
    return this.mainService.putModal(URL, data);
  }
  getVisitorList() {
    const URL = "/visitor/listactive"
    return this.mainService.get(URL);
  }
  createVisitor(data) {
    const URL = "/visitor/createorupdate";
    return this.mainService.postModal(URL, data);
  }

  findVisitor(data) {
    const URL = "/visitor/find"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL)
  }
  deleteVisitor(id) {
    const URL = "/visitor/delete?id=" + id;
    return this.mainService.delete(URL);
  }
  removeVisitorRGPD(data) {
    const URL = "/visitor/changestatus";
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }



  getVisitSettingsRuleAndCard() {
    const URL = "/visitRuleCardSetting/find"
    return this.mainService.get(URL);
  }

  updateRuleEnable(data) {
    const URL = "/visitRuleCardSetting/rule?ruleEnable=" + data
    return this.mainService.putModal(URL, data);
  }
  updateCardEnable(data) {
    const URL = "/visitRuleCardSetting/createorupdate"
    return this.mainService.postModal(URL, data);
  }

  getRgpdRulesandConditions() {
    const URL = "/visitRules/find"
    return this.mainService.get(URL);
  }

  createRulesandConditions(data) {
    const URL = "/visitRules/create"
    return this.mainService.postModal(URL, data);
  }



  getVisitCardList() {
    const URL = "/visitCards/findAll"
    return this.mainService.get(URL);
  }

  getVisitCard(id) {
    const URL = "/visitCards/find?id=" + id
    return this.mainService.get(URL);
  }

  createVisitCards(data) {
    const URL = "/visitCards/create"
    return this.mainService.postModal(URL, data);
  }

  deleteByVisitCardId(id) {
    const URL = "/visitCards/delete?id=" + id
    return this.mainService.delete(URL);
  }

  visitCardStatusChange(id) {
    const URL = "/visitCards/cardStatus?id=" + id;
    return this.mainService.get(URL)
  }


  //Order
  createOrder(data) {
    const URL = "/order/create"
    return this.mainService.postModal(URL, data);
  }
  getOrderList() {
    const URL = "/order/list"
    return this.mainService.get(URL);
  }

  getPendingOrderList() {
    const URL = "/order/pendingOrderlist"
    return this.mainService.get(URL);
  }

  updateByOrder(id){
    const URL = "/order/update?id=" + id
    return this.mainService.get(URL);
  }




  deleteByOrderId(id) {
    const URL = "/order/delete?id=" + id
    return this.mainService.delete(URL);
  }

  //Visits
  getVisitList() {
    const URL = "/visit/list";
    return this.mainService.get(URL);
  }
  getVisitorDropDownList() {
    const URL = "/visitor/nameList";
    return this.mainService.get(URL);
  }
  createVisit(data) {
    const URL = "/visit/create"
    return this.mainService.postModal(URL, data);
  }
  getVisitListByDate(data) {
    const URL = "/visit/listbydate";
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }

  //get Visit Lisit only  partially checkout 
  getPartialCheckOutListByDateAndLocationAndBuliding(data) {
    const URL = "/visit/partialCheckoutList";
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }

  findVisit(data){
    const URL = "/visit/find";
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  updateVisit(data) {
    const URL = "/visit/update"
    return this.mainService.putModal(URL, data);
  }

  firstLevelCheckIn(id) {
    const URL = "/visit/firstLevelCheckIn?visitId=" + id
    return this.mainService.get(URL);
  }
  checkinListView(id) {
    const URL = "/visit/checkinDates?visitId=" + id
    return this.mainService.get(URL);
  }
 secondLevelCheckIn(id){
    const URL = "/visit/secondLevelCheckIn?visitId=" + id
    return this.mainService.get(URL);
  }

  //checkout 
  visitCheckout(postData){
    const URL = "/visit/checkout?id="+postData.id+"&removeDataStatus="+postData.status
    return this.mainService.get(URL);
  }
  removeCardCheckout(id){
    const URL = "/visit/removecard?id="+id
    return this.mainService.get(URL);
  }

  getCardList(data) {
    const URL = "/visitCards/listbystatus"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }

  assignCardChecking(id,cardId){
    const URL = "/visit/assignCard?id="+id+"&cardId="+cardId
    return this.mainService.get(URL);
  }

  withoutCardCheckin(id){
    const URL = "/visit/checkinwithoutcard?visitId="+id
    return this.mainService.get(URL);
  }

  getCarrierList(){
    const URL = "/order/list/carrier"
    return this.mainService.get(URL);
  }


  //Visit Settings
  getVisitSettingsByLocation(data) {
    const URL = "/visitFields/getbycustomerlocation"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getVisitSettingsByBuilding(data) {
    const URL = "/visitFields/getbycustomerbuilding"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getVisitSettingsRuleAndCardByLocation(data){
    const URL = "/visitRuleCardSetting/getbycustomerlocation"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getVisitSettingsRuleAndCardByBuilding(data){
    const URL = "/visitRuleCardSetting/getbycustomerbuilding"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getRgpdRulesandConditionsByLocation(data) {
    const URL = "/visitRules/getbycustomerlocation"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getVisitCardListByLocation(data) {
    const URL = "/visitCards/getbycustomerlocation"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getVisitCardListByBuilding(data) {
    const URL = "/visitCards/getbycustomerbuilding"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getRgpdRulesandConditionsByBuilding(data) {
    const URL = "/visitRules/getbycustomerbuilding"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getOrderListFilter(data) {
    const URL = "/order/listbyfilter"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getPendingOrderListFilter(data) {
    const URL = "/order/pendingOrderlistfilter"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  changeVisitSettingStatus(data) {
    const URL = "/customerlocation/visitstatuschange"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getActiveAndActVisitCustomerLocations(data) {
    const URL = "/customerlocation/listactiveandvisitstatus";
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  changeVisitSettingStatusForBuilding(data) {
    const URL = "/building/visitstatuschange"
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
  getActiveBuildingListAndAcVisitByCustomerLocation(data) {
    const URL = "/building/listactivevisitstatus";
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }
//Laia 
  saveLaiaCustomerAdmin(customer) {
    const URL = "/user/save";
    return this.mainService.postModalForLaia(URL, customer);
  }
  updateLaiaCustomerAdmin(customer) {
    const URL = "/user/update";
    return this.mainService.putModalForLaia(URL, customer);
  }
  changeUserStatusForLaia(id) {
    const URL = "/user/changestatus?id=" + id;
    return this.mainService.getLaia(URL);
  }
  deleteLaiaCustomerAdmin(id) {
    const URL = "/user/delete?id=" + id;
    return this.mainService.deleteModelForLaia(URL);
  }
  getLaiaLicenseList(data){
    const URL = "/license/list";
    return this.mainService.getHttpServiceWithDynamicParamsForLaia(data, URL);
  }
  getLicenseDashboard(data){
    const URL = "/license/dashboard";
    return this.mainService.getHttpServiceWithDynamicParamsForLaia(data, URL);
  }
  downloadLicense(data){
    const URL = "/license/download";
    return this.mainService.getHttpServiceWithDynamicParamsForLaia(data, URL);
  }
  equipmentOrderStatusChange(data){
    const URL = "/customermobileequipment/orderStatusChange";
    return this.mainService.getHttpServiceWithDynamicParams(data, URL);
  }

  // saveorderNotes(id,notes) {
  //   const URL = "/order/saveOrderNotes?id=" + id+"&notes?="+notes;
  //   return this.mainService.get(URL);
  // }
  saveorderNotes(id: number, notes: string) {
    const URL = `/order/saveOrderNotes?id=${id}&notes=${encodeURIComponent(notes)}`;
    return this.mainService.get(URL);
}
}




